export default __webpack_public_path__ + "static/media/msrClose.a7613a8a.svg";